import React from 'react'

import Container from './Container'

import './Banner.scss'

const Banner = () =>
  <section className='Banner' role='status'>
    <Container className='Banner--container'>
      <h2>We Are Temporarily Closed</h2>
      <p>Pawsome Dogs is not taking new clients or scheduling lessons at this time. Thank you for your patience, and we look forward to seeing you and your pups again soon!</p>
    </Container>
  </section>

export default Banner
